export enum PlacementTab {
    SOLUTIONS = 'Solutions',
    CATALOGUE = 'Catalogue'
}
